export default __webpack_public_path__ + "static/media/image.edus-online-institute.ddd138f3.png";